module.exports = __webpack_public_path__ + "img/phone_step2.d2c2f0ad.png";